const DownArrowIcon = ({ color = 'white' }) => {
    return (
        <svg
            width='10'
            height='10'
            viewBox='0 0 7 4'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M0.749605 0.70415L1.44554 0.00415039L3.73216 2.30415L6.01879 0.00415039L6.71472 0.70415L3.73216 3.70415L0.749605 0.70415Z'
                fill={color}
            />
        </svg>
    );
};

export default DownArrowIcon;
